import Core from "./core"
import VisitFlow from '@hub/settings/src/modules/visit-flows/store'
import TermsAudit from "@hub/settings/src/modules/terms/store"
import NoteTypes from "@hub/settings/src/modules/note-types/store"
import Provider from "@hub/settings/src/modules/provider/store"
import Flow from '@hub/settings/src/modules/flows/store'
import BiometryFlow from '@hub/settings/src/modules/biometry-flows/store'
import Dashboards from '@hub/settings/src/modules/dashboards/store'

const Store = {
  namespaced: true,
  modules: {
    Core,
    TermsAudit,
    NoteTypes,
    Provider,
    Flow,
    VisitFlow,
    BiometryFlow,
    Dashboards
  }
}

export default Store
